"use client"

import { signal } from './vidstack-CZgUA94N.js';

const RemotionThumbnail = /* @__PURE__ */ signal(null);
const RemotionSliderThumbnail = /* @__PURE__ */ signal(null);
const RemotionPoster = /* @__PURE__ */ signal(null);

export { RemotionPoster, RemotionSliderThumbnail, RemotionThumbnail };
